module.exports = __webpack_public_path__ + "static/media/YF84_7.00c5d238.jpg";